import { useState } from "react";
import { Link } from "react-router-dom";
import "./mutual-fund-sections.css";

const FUNDS = [
  {
    name: "Parag Parikh Flexi Cap Fund",
    category: "Flexi Cap",
    risk: "Moderately High",
    riskTone: "orange",
    y1: "22.45%",
    y3: "18.92%",
    expense: "0.63%",
    sip: "₹1,000",
  },
  {
    name: "Mirae Asset Large Cap Fund",
    category: "Large Cap",
    risk: "Moderate",
    riskTone: "green",
    y1: "16.80%",
    y3: "14.25%",
    expense: "0.54%",
    sip: "₹500",
  },
  {
    name: "SBI Small Cap Fund",
    category: "Small Cap",
    risk: "High",
    riskTone: "red",
    y1: "28.15%",
    y3: "24.60%",
    expense: "0.72%",
    sip: "₹500",
  },
  {
    name: "HDFC Mid-Cap Opportunities",
    category: "Mid Cap",
    risk: "Moderately High",
    riskTone: "orange",
    y1: "24.10%",
    y3: "20.35%",
    expense: "0.81%",
    sip: "₹1,000",
  },
  {
    name: "ICICI Prudential Liquid Fund",
    category: "Liquid",
    risk: "Low",
    riskTone: "teal",
    y1: "7.15%",
    y3: "6.40%",
    expense: "0.20%",
    sip: "₹500",
  },
];

const STRATEGY_POINTS = [
  { icon: "fa-bullseye", label: "Financial Goals" },
  { icon: "fa-gauge-high", label: "Risk Appetite" },
  { icon: "fa-clock", label: "Time Horizon" },
  { icon: "fa-wallet", label: "Investment Amount" },
  { icon: "fa-chart-pie", label: "Asset Preference" },
  { icon: "fa-calendar-check", label: "Tax Planning" },
];

const TESTIMONIALS = [
  {
    text: "GPS helped me build a diversified mutual fund portfolio that aligns with my retirement goals. Clear advice and excellent support.",
    name: "Rajesh Kumar",
    role: "Business Owner",
    img: "/images/user1.jpg",
  },
  {
    text: "As a busy professional, I needed simple investing. Their personalized SIP plan and fund picks have been outstanding.",
    name: "Priya Sharma",
    role: "Software Engineer",
    img: "/images/user2.jpg",
  },
  {
    text: "Transparent process, trusted research, and a dedicated relationship manager — investing finally feels confident.",
    name: "Amit Patel",
    role: "Doctor",
    img: "/images/user3.jpg",
  },
  {
    text: "From KYC to portfolio tracking, everything was smooth. Highly recommend GPS Finvest for mutual fund investing.",
    name: "Neha Verma",
    role: "Entrepreneur",
    img: "/images/user1.jpg",
  },
];

const TRUST = [
  {
    icon: "fa-certificate",
    title: "SEBI Registered",
    desc: "AMFI Registered Mutual Fund Distributor",
  },
  {
    icon: "fa-lock",
    title: "Secure Transactions",
    desc: "Bank-level security for safe investments",
  },
  {
    icon: "fa-shield-halved",
    title: "Data Protection",
    desc: "Your data is encrypted and 100% secure",
  },
  {
    icon: "fa-award",
    title: "High Trust",
    desc: "Trusted by 10,000+ happy investors worldwide",
  },
];

function handleInvest(e) {
  const encryptedData = localStorage.getItem(
    process.env.REACT_APP_LOGIN_DATA_STORE
  );
  if (!encryptedData) {
    e.preventDefault();
    window.location.href = "https://gpsfinvest.investwell.app/app/#/login";
  } else {
    window.scrollTo({ top: 0, behavior: "instant" });
  }
}

export default function MutualFundFeatured() {
  const [slide, setSlide] = useState(0);
  const visibleCount = 3;
  const maxSlide = Math.max(0, TESTIMONIALS.length - visibleCount);

  const prev = () => setSlide((s) => Math.max(0, s - 1));
  const next = () => setSlide((s) => Math.min(maxSlide, s + 1));

  return (
    <>
      {/* Featured Mutual Funds */}
      <section className="mf-featured" id="compare">
        <div className="mf-featured-inner">
          <header className="mf-sec-header">
            <p className="mf-sec-eyebrow">TOP PICKS</p>
            <h2 className="mf-sec-title">Featured Mutual Funds</h2>
          </header>

          <div className="mf-table-wrap">
            <table className="mf-funds-table">
              <thead>
                <tr>
                  <th>Fund Name</th>
                  <th>Category</th>
                  <th>Risk Level</th>
                  <th>1Y Returns</th>
                  <th>3Y Returns</th>
                  <th>Expense Ratio</th>
                  <th>Min. SIP</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {FUNDS.map((f) => (
                  <tr key={f.name}>
                    <td data-label="Fund Name">
                      <strong>{f.name}</strong>
                    </td>
                    <td data-label="Category">{f.category}</td>
                    <td data-label="Risk Level">
                      <span className={`mf-risk-badge tone-${f.riskTone}`}>
                        {f.risk}
                      </span>
                    </td>
                    <td data-label="1Y Returns" className="mf-ret">
                      {f.y1}
                    </td>
                    <td data-label="3Y Returns" className="mf-ret">
                      {f.y3}
                    </td>
                    <td data-label="Expense Ratio">{f.expense}</td>
                    <td data-label="Min. SIP">{f.sip}</td>
                    <td data-label="Action">
                      <Link
                        to="/clientmutualfunds"
                        className="mf-invest-btn"
                        onClick={handleInvest}
                      >
                        Invest Now
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Strategy CTA */}
      <section className="mf-strategy-cta">
        <div className="mf-strategy-inner">
          <div className="mf-strategy-art" aria-hidden="true">
            <div className="mf-target">
              <span />
              <span />
              <span />
              <i className="fa-solid fa-location-arrow" />
            </div>
          </div>

          <div className="mf-strategy-copy">
            <h2>Not Sure Which Fund is Right for You?</h2>
            <p>
              Answer a few questions and get a personalized mutual fund strategy
              based on your goals and risk profile.
            </p>
            <div className="mf-strategy-points">
              {STRATEGY_POINTS.map((p) => (
                <div key={p.label} className="mf-strategy-point">
                  <i className={`fa-solid ${p.icon}`} aria-hidden="true" />
                  <span>{p.label}</span>
                </div>
              ))}
            </div>
          </div>

          <Link to="/contact" className="mf-strategy-btn">
            Find My Strategy →
          </Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="mf-testimonials">
        <div className="mf-testimonials-inner">
          <header className="mf-sec-header">
            <p className="mf-sec-eyebrow">INVESTOR STORIES</p>
            <h2 className="mf-sec-title">Trusted by Thousands of Investors</h2>
          </header>

          <div className="mf-testimonials-carousel">
            <button
              type="button"
              className="mf-carousel-nav prev"
              onClick={prev}
              disabled={slide === 0}
              aria-label="Previous testimonials"
            >
              <i className="fa-solid fa-chevron-left" />
            </button>

            <div className="mf-testimonials-viewport">
              <div
                className="mf-testimonials-track"
                style={{
                  transform: `translateX(-${slide * (100 / visibleCount)}%)`,
                }}
              >
                {TESTIMONIALS.map((t) => (
                  <article key={t.name + t.role} className="mf-testimonial-card">
                    <div className="mf-stars" aria-label="5 star rating">
                      ★★★★★
                    </div>
                    <p className="mf-quote">“{t.text}”</p>
                    <div className="mf-author">
                      <img src={t.img} alt="" />
                      <div>
                        <strong>{t.name}</strong>
                        <span>{t.role}</span>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            <button
              type="button"
              className="mf-carousel-nav next"
              onClick={next}
              disabled={slide >= maxSlide}
              aria-label="Next testimonials"
            >
              <i className="fa-solid fa-chevron-right" />
            </button>
          </div>
        </div>
      </section>

      {/* Trust & Security */}
      <section className="mf-trust">
        <div className="mf-trust-inner">
          <header className="mf-sec-header">
            <p className="mf-sec-eyebrow">TRUST & SECURITY</p>
            <h2 className="mf-sec-title">Your Investments. Always Protected.</h2>
          </header>

          <div className="mf-trust-panel">
            {TRUST.map((item) => (
              <div key={item.title} className="mf-trust-item">
                <div className="mf-trust-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </div>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
